export default [
  {
    alias: 'value',
    value: null
  }
];
